import Icon from './Icon';

const Edit = (props) => (
  <Icon
    {...props}
    path="M71.767 21.033l-12.8-12.8c-0.452-0.452-1.077-0.731-1.767-0.731s-1.314 0.279-1.767 0.731v0l-47.2 47.2c-0.453 0.452-0.733 1.077-0.733 1.767v12.8c0 1.381 1.119 2.5 2.5 2.5v0h12.8c0.69-0.001 1.315-0.281 1.767-0.733v0l47.2-47.2c0.452-0.452 0.731-1.077 0.731-1.767s-0.279-1.314-0.731-1.767v0zM21.767 67.5h-9.267v-9.267l32.5-32.5 9.233 9.267zM57.767 31.467l-9.233-9.267 8.667-8.667 9.267 9.267z"
  />
);

export default Edit;
